const NavigationPublic = [
  {
    id: 'Home',
    title: 'Home',
    type: 'item',
    url: 'home'
  },
  {
    id: 'AboutUs',
    title: 'About us',
    type: 'item',
    url: 'aboutUs'
  },
  {
    id: 'Services',
    title: 'Services',
    type: 'item',
    url: 'services'
  },
  {
    id: 'Contacts',
    title: 'Contacts',
    type: 'item',
    url: 'contacts'
  },
];

export default NavigationPublic;
